<template v-if="userData">
  <div class="p-4 bg-white rounded-lg">
    <analytics-layout
      :userData="userData"
      :updateDashboardData="updateDashboardData"
      :filters="filters"
    ></analytics-layout>
  </div>
</template>

<script>
import { UPDATE_DASHBOARD_DATA } from "@/core/services/store/analytics.module";
import AnalyticsLayout from "@/own/components/dashboard/AnalyticsLayoutNew.vue";
export default {
  components: { AnalyticsLayout },
  name: "Analitics",
  data: () => ({
    data: null,
  }),
  methods: {
    getToday() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    updateDashboardData(
      serverData = {
        date_range_type: "today",
        date_range: [this.getToday(), this.getToday()],
      }
    ) {
      if (serverData.date === "custom") {
        this.$store.dispatch(UPDATE_DASHBOARD_DATA, serverData).then(() => {
          this.data = this.$store.getters.getANALYTICSTableData;
        });
      } else {
        this.$store.dispatch(UPDATE_DASHBOARD_DATA, serverData).then(() => {
          this.data = this.$store.getters.getANALYTICSTableData;
        });
      }
      this.data = this.$store.getters.getANALYTICSTableData;
    },
  },
  computed: {
    filters: function () {
      return this.$store.getters.getANALYTICSFilter;
    },
    userData: function () {
      return this.data;
    },
  },
  beforeMount() {
    this.updateDashboardData();
  },
};
</script>
